/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-square-save': {
    width: 43.412,
    height: 43.411,
    viewBox: '0 0 43.412 43.411',
    data:
      '<defs><clipPath id="svgicon-social-square-save-a"><path pid="0" data-name="Rectangle 243" d="M0 0h25.299v25.081H0z" _fill="none"/></clipPath></defs><g data-name="Group 1609"><path pid="1" data-name="Path 422" d="M5.867 0h31.679a5.867 5.867 0 0 1 5.866 5.866v31.679a5.866 5.866 0 0 1-5.866 5.866H5.867A5.866 5.866 0 0 1 0 37.545V5.864A5.867 5.867 0 0 1 5.867-.002"/><path pid="2" data-name="Rectangle 241" d="M20.518 12.951h2.907v4.052h-2.907z" _fill="#fff"/><g data-name="Group 958"><g data-name="Group 957" transform="translate(9.326 9.318)" clip-path="url(#svgicon-social-square-save-a)"><path pid="3" data-name="Path 423" d="M20.558-.001H1.615A1.614 1.614 0 0 0 0 1.613v21.852a1.614 1.614 0 0 0 1.615 1.614h22.069a1.615 1.615 0 0 0 1.616-1.614V5.27zM3.6 2.286h11.887v7.157H3.601zm0 10.254h18.085v10.09H3.601z" _fill="#fff"/></g></g></g>'
  }
})
